import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the service worker (production builds only — dev gets HMR
// which would conflict). On second+ visits the shell loads from cache
// even if Cloudflare's edge has a transient ERR_CONNECTION_RESET.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW registration is best-effort. App still works without it,
      // just without offline / edge-failure resilience.
    });
  });
}
